export const NotificationType = Object.freeze({
  ALERT: "ALERT",
  ORDER_STATUS: "ORDER_STATUS",
  INFO: "INFO",
  PROMOTION: "PROMOTION",
});

export const NotificationPriority = Object.freeze({
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high",
});

export const PRIORITY_OPTIONS = Object.freeze([
  { value: NotificationPriority.LOW, label: "Low", color: "grey.500", bgColor: "grey.100" },
  { value: NotificationPriority.MEDIUM, label: "Medium", color: "warning.main", bgColor: "warning.lighter" },
  { value: NotificationPriority.HIGH, label: "High", color: "error.main", bgColor: "error.lighter" },
]);
